module.exports = __webpack_public_path__ + "static/media/29FUNOV6.60491338.jpg";